export default __webpack_public_path__ + "static/char-thumb-55-fb18dba513ec8a3b8f8519934dcaf1a3.png";